/* eslint-disable @typescript-eslint/no-shadow */
import { ChannelInfo } from './ChannelInfo';
import { ParticipantGroups } from '../ParticipantGroups';

export class ChannelInfoViewModel {
  public static createEmpty(): ChannelInfoViewModel {
    // entity of chat
    return new ChannelInfoViewModel();
  }
  constructor(
    public Channels: ChannelInfo[] = [],
    public ParticipantGroups: ParticipantGroups[] = [],
  ){}
}
